
import { defineComponent } from 'vue'
import { translate } from '@/core/services/translation-service'

export default defineComponent({
  setup() {
    const content = '<h1>Your first visit</h1><p>Lorem ipsum</p>'

    return {
      content,
      translate
    }
  }
})
